import React from 'react';

import { telemetryConsumerWrapper } from '~commonInfra/telemetryEvents/contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '~commonInfra/telemetryEvents/contexts/TelemetryContexts';
import { ContentClickedEventHandler } from '~commonInfra/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '~commonInfra/telemetryEvents/util/EventHandlerFactories';
import { SiteUrlsProps } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { DataSources } from '~src/datasource/resources/Datasources';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';

import { Messages } from '../../../codegen/Localize';
import { L10n } from '../../../commonInfra/L10n/L10n';
import { ExtractEncryptionMode } from '../../../commonInfra/utils/sites/SitePropertyTypes';
import { CommonDatasourceInfo } from '../../models/mappers/CommonDatasourceInfo';

export type DetailedDatasourceThumbnailOwnProps = Pick<React.AriaAttributes, 'aria-label'> & {
  readonly datasource: CommonDatasourceInfo;
  readonly contentUrl: string;
  readonly showExtractEncryptionStatus: boolean;
  readonly allowDragAndDrop: boolean;
  readonly hoveredOrSelected?: boolean;
}

export interface DetailedDatasourceThumbnailStateProps {
  readonly siteEARMode: ExtractEncryptionMode;
}

export type DetailedDatasourceThumbnailProps =
  SiteUrlsProps & DetailedDatasourceThumbnailOwnProps & DetailedDatasourceThumbnailStateProps;

export class DetailedDatasourceThumbnail extends React.Component<DetailedDatasourceThumbnailProps> {
  public render() {
    const containerClass = this.props.hoveredOrSelected ?
      (this.props.contentUrl ? CardViewStyles.CustomThumbnailHover : CardViewStyles.CustomThumbnailHoverNoPointer)
      : CardViewStyles.CustomThumbnail;
    /* eslint-disable jsx-a11y/alt-text */
    return (
      <div className={containerClass}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={CardViewStyles.DatasourceCustomThumbnailImg}>
                <img
                  src={DataSources.getIconForDatasourceType(this.props.datasource, 'card')}
                  width={'60px'} height={'60px'}
                  data-tb-test-id={DataSources.isCertified(this.props.datasource) ? 'certification-icon' : ''}/>
            </div>
            <div>
            {DataSources.DatasourceStatus(this.props.showExtractEncryptionStatus,this.props.datasource.connectionType,this.props.datasource.isFileBased, DataSources.isExtract(this.props.datasource), this.props.datasource.extractEncryptionState, this.props.datasource.extractCreationPending, this.props.siteEARMode)}
            </div>
          </div>
          <div>
            {this.lastRefreshTime()}
          </div>
        </div>
        {this.props.contentUrl &&
          telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
            /* eslint-disable jsx-a11y/anchor-has-content */
            <a
              onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}
              href={this.props.contentUrl}
              className={CardViewStyles.AnchorUnderlay}
              /**
               * If card reordering allowed, disable link dragging.
               * Otherwise, set `draggable` explicitly to undefined rather than true.
               * (When `draggable` is true, the browser-provided drag avatar looks too similar
               * to the reorder card feature's avatar, which may confuse users.)
               */
              draggable={this.props.allowDragAndDrop ? false : undefined}
              aria-label={this.props['aria-label']}
            ></a>
          )
        }
      </div>
    );
  }

  private lastRefreshTime = (): JSX.Element => {
    const dateTime = this.props.datasource.lastRefreshedAt;
    return dateTime ? <span>{Messages.lastRefresh()} {L10n.localizedDateTime(dateTime)}</span> : <span>&nbsp;</span>;
  };
}
